module.exports = __webpack_public_path__ + "static/media/finished.b193ea3a.svg";